import { render, staticRenderFns } from "./CrewChange.vue?vue&type=template&id=ede2ebba&scoped=true"
import script from "./CrewChange.vue?vue&type=script&lang=js"
export * from "./CrewChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede2ebba",
  null
  
)

export default component.exports